export const CURRENCIES = {
  USD: "usdt",
  USDT: "usdt",
  INR: "inr",
};
export const CURRENCIES_WITH_DIFFERENT_UNIT = {
  usd: "usdt",
};
